import { ListViewChildProps } from '@app/core/list-view/ListView';
import { auditReports } from '@mi-front/api-clients';
import { MrtTable } from '@mi-front/ui';
import { Box } from '@mui/material';
import { useIntl } from 'react-intl';
import { aodRoutes } from '../../routing/routes';
import { createPastRunsColumns } from './PastRunsColumns';
import { useAutoRefreshRuns } from './useAutoRefreshRuns';

export type AodRunsListProps = ListViewChildProps<auditReports.AodRunInGetManyDto>;

/**
 * Table component for AOD Runs List V2.
 * Displays runs in a table without column filters (filters are in the ListView filter bar).
 */
export function AodRunsList(props: AodRunsListProps) {
  const { formatMessage } = useIntl();
  const {
    data,
    total,
    pagination,
    onPaginationChange,
    sorting,
    onSortingChange,
    isLoading = false,
    isFetching = false,
    showProgress = true,
  } = props;

  useAutoRefreshRuns({ runs: data });

  return (
    <Box>
      <MrtTable<auditReports.AodRunInGetManyDto>
        data={data}
        rowCount={total}
        state={{
          pagination,
          sorting,
          isLoading,
          showProgressBars: showProgress && (isLoading || isFetching),
        }}
        onPaginationChange={onPaginationChange}
        onSortingChange={onSortingChange}
        manualPagination
        manualSorting
        enableColumnFilters={false}
        enableToolbarInternalActions={false}
        paginationDisplayMode="default"
        // TODO: refactor
        muiTopToolbarProps={{
          sx: {
            height: '4px !important',
            minHeight: '4px !important',
          },
        }}
        navigateToOnClick={(id) => aodRoutes.runView.gen(id)}
        columns={createPastRunsColumns(formatMessage, {
          includeRuleName: true,
          includeReportType: true,
          includeReportLink: true,
        })}
      />
    </Box>
  );
}
